import { createContext, useContext, useState, useCallback } from "react";

const ConfirmCtx = createContext(null);

export function ConfirmProvider({ children }) {
  const [state, setState] = useState(null);

  const confirm = useCallback((opts) => new Promise((resolve) => {
    setState({ ...opts, resolve });
  }), []);

  const close = (result) => {
    if (state?.resolve) state.resolve(result);
    setState(null);
  };

  return (
    <ConfirmCtx.Provider value={confirm}>
      {children}
      {state && (
        <div className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4" onClick={()=>close(false)}>
          <div onClick={e=>e.stopPropagation()} className="w-full max-w-md border border-white/20 bg-[#12151A] p-6 corner-tick" data-testid="confirm-dialog">
            <div className="label-mono text-[#C0393E]">::: CONFIRM ACTION</div>
            <div className="font-display text-2xl mt-3">{state.title || "Are you sure?"}</div>
            {state.message && <div className="text-white/70 mt-3 text-sm leading-relaxed">{state.message}</div>}
            <div className="mt-6 flex gap-2 justify-end">
              <button onClick={()=>close(false)} className="btn-cta" data-testid="confirm-cancel">{state.cancelLabel || "Cancel"}</button>
              <button onClick={()=>close(true)} className={`btn-cta ${state.destructive ? "danger" : "primary"}`} data-testid="confirm-ok">{state.confirmLabel || "Confirm"}</button>
            </div>
          </div>
        </div>
      )}
    </ConfirmCtx.Provider>
  );
}

export const useConfirm = () => useContext(ConfirmCtx);
